
define('app/ko-app-mobile',['jquery',
        'knockout',
        'bootstrap'],
    function ($, ko) {
        var container;
        
        function skipMobile(modal) {
            var result = false;
            if (modal.parent().attr('id') == 'errorModalContainer'
                || modal.hasClass('skip-modal-mobile')
                || modal.hasClass('loading')
                || (modal.hasClass('skip-tablet') && window.isTablet))
                result = true;
            return result;
        }

        function enableMobileModal() {
            window.activeModals = 0;
            $(document).on('show.bs.modal popupOpened', function (e) {
                if (skipMobile($(e.target)))
                    return;
                
                if (window.isPhoneOrTablet && e.target.id == "choosePerson")
                    window.lastScroll = 0;
                else
                    window.lastScroll = $(document).scrollTop();
                
                $('body').addClass('mobile-modal-opening');
                $('.dropdown.open').removeClass('open');

            });
            
            $(document).on('shown.bs.modal popupOpened', function (e) {
                if (skipMobile($(e.target)))
                    return;
                $('body').addClass('mobile-modal-open');
                $('body').removeClass('mobile-modal-opening');
                var modal = $(e.target);
                container = $('#modal_mobile_container');
                window.activeModals++;
                if (!container.length) {
                    $(container).append('<div class="select-flight select-flight-mobile"></div>');
                }
                if (!modal.parent().hasClass('modal_mobile_container')) {
                    var selectFlight = modal.closest('.select-flight');
                    if (selectFlight.length && !selectFlight.hasClass('select-flight-mobile')) {
                        modal.appendTo('.select-flight-mobile');
                    } else if (!modal.parent().hasClass('select-flight-mobile')) {
                        modal.appendTo(container);
                    }
                }
                
                if (window.isPhoneOrTablet) {
                	if(modal.parent().hasClass('select-flight-mobile')) {
	                	$('body').addClass('height-0');
	                } else {
		                var hgt = window.innerHeight;
		                var hgtMdl = $(e.target).find('.modal-dialog').height();
		                if(hgt < hgtMdl)
		                	$('body').addClass('noScrollbody');
                      $("html").addClass("overflow-x-hidden");
                      $("body").addClass("overflow-x-hidden");
	                }
	            }

            });
            
            $(document).on('hidden.bs.modal popupClosed', function (e) {
                if (skipMobile($(e.target)))
                    return;
                $('body').removeClass('mobile-modal-open noScrollbody height-0 overflow-x-hidden');
                $("html").removeClass("overflow-x-hidden");
                window.activeModals > 0 && window.activeModals--;

            });
            
            $(document).ready(function (e) {
                container = $('#modal_mobile_container');
                if (!$('.select-flight-mobile').length) {
                    $(container).append('<div class="select-flight select-flight-mobile"></div>');
                }
            });
        }
        
        if(window.isPhoneOrTablet) {
            enableMobileModal();

            $("input,textarea").on("focus focusin", function() {
                if($('*[class^="fixed-price-bar"]').is(':visible')) {
                    var topOffset = $(this).offset().top - 20;
                    setTimeout(function() {
                        $('html, body').stop().animate({ scrollTop: topOffset }, "slow");
                    }, 500);
                }
            });

            // Tooltip position edit for mobile devices
            setTimeout(function(){
                $(document).on('show.bs.tooltip','[data-bs-toggle="tooltip"]', function () {
                    $('body').addClass('relative')
                })
                $(document).on('hidden.bs.tooltip','[data-bs-toggle="tooltip"]', function () {
                    $('body').removeClass('relative')
                })
            },150)
        }

    });
	